// src/modules/app-views/crm/pages/Boards/modals/QuickCaptureModal/Step3NextAction.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row, Typography, Form, Switch } from 'antd';
import SimpleDatePicker from 'components/SimpleComponents/SimpleDatePicker';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import { useSimpleFormContext } from 'components/SimpleComponents/SimpleFormProvider';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step3NextAction = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const { form } = useSimpleFormContext();

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const createEvent = Form.useWatch('createEvent', form);

  const eventTypeOptions = [
    { value: 'reminder', text: translateX('reminder') },
    { value: 'call', text: translateX('call') },
    { value: 'meeting', text: translateX('meeting') },
    { value: 'email', text: translateX('email') },
    { value: 'task', text: translateX('task') },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="p-2">
      <Row gutter={16}>
        <Col xs={24}>
          <Form.Item name="createEvent" valuePropName="checked" style={{ marginBottom: 16 }}>
            <Switch checkedChildren={translateX('create_event')} unCheckedChildren={translateX('skip')} />
          </Form.Item>
        </Col>
      </Row>

      {createEvent ? (
        <>
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <SimpleDatePicker
                name="eventDate"
                label="date"
                required
              />
            </Col>
            <Col xs={24} sm={12}>
              <SimpleSelect
                name="eventType"
                label="event_type"
                options={eventTypeOptions}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24}>
              <SimpleInput
                name="eventTitle"
                label="event_title"
              />
            </Col>
          </Row>
        </>
      ) : (
        <Text type="secondary" style={{ display: 'block', paddingTop: 8 }}>
          {translateX('quick_capture_skip_event_hint')}
        </Text>
      )}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step3NextAction;
